module.exports = __webpack_public_path__ + "static/img/NL@3x.0000b405.jpg";